import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 개발/검수진 한마디 ")

import { ref } from "vue";
import { useDisplay } from "vuetify";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { xs, smAndUp } = useDisplay();

const items = ref([
  {
    image: require("../../assets/comments/comments/comments_1.webp"),
    title: "이대목동병원 신경과 김건하",
    content:
      "'새미톡'은 누구나 쉽게 스마트폰으로 접근 가능한 카카오톡을 활용해 간단하고 재미있는 인지 강화 게임을 할 수 있는 서비스",
  },
  {
    image: require("../../assets/comments/comments/comments_2.webp"),
    title: "HCI 권위자 김진우 교수",
    content:
      "매주 정기적으로 의료센터에 가서 상담사와 함께했던 훈련을 매일 집에서 이용할 수 있도록 한 서비스",
  },
]);

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "elevation-0" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, {
        class: _normalizeClass(["font-weight-medium text-center justify-center", { 'text-h5': _unref(xs), 'text-h4': _unref(smAndUp) }])
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_v_spacer, { class: "py-4" }),
      _createVNode(_component_v_card, {
        class: "elevation-0 mx-auto",
        style: {"max-width":"800px"}
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
            return (_openBlock(), _createBlock(_component_v_row, {
              key: index,
              class: "reverse",
              justify: "center",
              align: "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "auto" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "rounded-circle",
                      style: _normalizeStyle([{
              backgroundImage: 'url(' + item.image + ')',
            }, {"width":"12rem","height":"12rem","background-size":"cover","background-position":"center"}])
                    }, null, 4)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, {
                      class: _normalizeClass(["font-weight-bold", { 'text-h6 justify-center': _unref(xs), 'text-h5': _unref(smAndUp) }])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["class"]),
                    _createVNode(_component_v_divider),
                    _createVNode(_component_v_card_text, {
                      class: _normalizeClass(["font-weight-medium", {
              'text-body-2 text-center pb-6': _unref(xs),
              'text-body-1': _unref(smAndUp),
            }]),
                      style: {"word-break":"keep-all"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.content), 1)
                      ]),
                      _: 2
                    }, 1032, ["class"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})